import { FC } from 'react';
import { useLocation, useNavigation } from '@remix-run/react';
import { EPageType, PageTypeUtils } from 'shared/models/page-type';
import { DiscoverFullSkeleton } from '~/skeleton/discover';
import { FeedSkeleton } from '~/skeleton/feed';
import { ArticleSkeleton } from '~/skeleton/article';
import { UserFullSkeleton } from '~/skeleton/user';
import { POIFullSkeleton } from '~/skeleton/poi';
import { Loading } from '~/components/loading';
import { HashtagSkeleton } from '~/skeleton/hashtag';

import './common/style/index.scss';

export const RootSkeleton: FC = () => {
  const { location: navigationLocation } = useNavigation();
  const currentLocation = useLocation();

  const { pathname } = navigationLocation || currentLocation;
  const pageType = PageTypeUtils.getPageTypeFromPathname(pathname);

  if (pageType === EPageType.discover) {
    return <DiscoverFullSkeleton />;
  }

  if (pageType === EPageType.feed) {
    return <FeedSkeleton />;
  }

  /**
   * cannot distinct page type from video and article by pathname only.
   */
  if (
    pageType === EPageType.article ||
    pageType === EPageType.video ||
    pageType === EPageType.experience ||
    pageType === EPageType.experience_article ||
    pageType === EPageType.experience_ugc
  ) {
    return <ArticleSkeleton />;
  }

  if (pageType === EPageType.user) {
    return <UserFullSkeleton />;
  }

  if (pageType === EPageType.poi) {
    return <POIFullSkeleton />;
  }

  if (pageType === EPageType.hashtag) {
    return <HashtagSkeleton />;
  }

  return <Loading variant="ball" />;
};
